import {setGlobalOptions} from '../loader-utils/option-utils';

// Set global loader options
export function setLoaderOptions(options) {
  setGlobalOptions(options);
}
